import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatPlanPercentage } from 'modules/estatePlan/helpers';

const useCongratsText = () => {
  const { t } = useTranslation(['plan']);
  const planProgress: PlanProgressDTO = useSelector(
    (state: any) => state.plan.progress
  );
  const percentValue = formatPlanPercentage(planProgress?.overall);

  return useMemo(() => {
    if (planProgress?.overall === 0.1 && planProgress?.introduction === 1) {
      return t('plan:congrats_with_introduction_only');
    }

    if (percentValue === 0) {
      return t('plan:congrats_with_zero_percent');
    }

    return t('plan:congrats_with_percent', { percentValue });
  }, [percentValue, planProgress?.introduction, planProgress?.overall, t]);
};

export default useCongratsText;
